import {
  Ballot as BallotIcon,
  MoneyOff as MoneyOffIcon,
  Gavel as GavelIcon,
} from '@material-ui/icons';

import navAmlItems from './aml';

const items = [
  {
    icon: BallotIcon,
    items: [
      {
        href: '/condusef/redeco',
        module: 'condusef',
        title: 'REDECO',
      },
      {
        href: '/condusef/reune',
        module: 'condusef',
        title: 'REUNE',
      },
    ],
    module: 'condusef',
    title: 'condusef',
  },
  {
    icon: MoneyOffIcon,
    items: navAmlItems,
    module: 'pld',
    title: 'aml',
  },
  {
    icon: GavelIcon,
    items: [
      {
        href: '/vulnerable_activities/legal_framework',
        module: 'vulnerableActivities',
        title: 'legal_framework',
      },
      {
        href: '/vulnerable_activities/identification_notice_thresholds',
        module: 'vulnerableActivities',
        title: 'identification_notice_thresholds',
      },
      {
        href: '/vulnerable_activities/threshold_control',
        module: 'vulnerableActivities',
        title: 'threshold_control',
      },
    ],
    module: 'vulnerableActivities',
    title: 'vulnerable_activities',
  },
];

export default items;
